import { render, staticRenderFns } from "./DonationSetting.vue?vue&type=template&id=34d09be8&scoped=true"
import script from "./DonationSetting.vue?vue&type=script&lang=js"
export * from "./DonationSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d09be8",
  null
  
)

export default component.exports